import { render, staticRenderFns } from "./proceed_detail_m.vue?vue&type=template&id=5d27294c&scoped=true&"
import script from "./proceed_detail_m.vue?vue&type=script&lang=js&"
export * from "./proceed_detail_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d27294c",
  null
  
)

export default component.exports